import React, { useState, useEffect, useRef } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { useHistory, useParams } from "react-router-dom";
import UserService from "../../services/user.service";
import Loading from "../../common/Loading";
import moment from "moment";
import Select from "react-select";
import InfiniteScroll from "react-infinite-scroll-component";
import { customStyles, customStylesError } from "../../common/CustomStyles";

const Reminders = (props) => {
  let { uuid } = useParams();
  let history = useHistory();
  const sortRef = useRef(null); // Ref for the dropdown button

  const [loadingspinner, setloadingspinner] = useState(true);
  const [loading, setloading] = useState(false);

  const UserDetails = JSON.parse(localStorage.getItem("UserDetails"));
  const uuidDetails = localStorage.getItem("uuid");
  const userUuidDetails = JSON.parse(localStorage.getItem("userUUID"));
  const parentUserUUId = localStorage.getItem("parentUser.uuid");
  const PrimaryIdval = localStorage.getItem("PrimaryIdval");
  const [filtAll, setfiltAll] = useState([]);
  const [selectedSort, setSelectedSort] = useState(); // Selected option for sort dropdown
  const [isSortDropdown, setIsSortDropdown] = useState(false);
  const [filterVal, setfilterVal] = useState("all");
  const [tabVal, settabVal] = useState("other");
  const [limit, setLimit] = useState(50);
  const [offset, setOffset] = useState(0);
  const [activeButton, setActiveButton] = useState("other"); // Initial state set to 'voucher'
  const [allData, setAllData] = useState([]);
  const [isEmpty, setIsEmpty] = useState(false);
  const [familyUserId, setfamilyUserId] = useState();
  const [familyId, setfamilyId] = useState();
  const [hasMore, sethasMore] = useState(false);

  useEffect(() => {
    var userType = localStorage.getItem("userType");
    const userArr = [
      { value: "all", label: "All" },
      { value: "expired", label: "Expired" },
    ];
    const primaryArr = [{ value: "expired", label: "Expired" }];
    const primaryArrVal = [];

    UserService.getFamilyAllAu(uuid).then(
      (resp) => {
        for (let i = 0; i < resp.data.length; i++) {
          userArr.push({
            value: resp.data[i].id,
            label: resp.data[i].User.email,
          });

          if (parseInt(PrimaryIdval) === resp.data[i].id) {
            primaryArr.push({
              value: resp.data[i].id,
              label: resp.data[i].User.email,
            });
            primaryArrVal.push({
              value: resp.data[i].id,
              label: resp.data[i].User.email,
            });
          }
          if (
            userType === "AO" ||
            userType === "AO + SU" ||
            userType === "AO + AU" ||
            userType === "AO + AU + SU"
          ) {
            setfiltAll(userArr);
            setSelectedSort({
              value: "all",
              label: "All",
            }); // Selected option for sort dropdown
          } else {
            setfiltAll(primaryArr);
            primaryArrVal[0] &&
              setSelectedSort({
                value: primaryArrVal[0].value,
                label: primaryArrVal[0].label,
              }); // Selected option for sort dropdown
          }
        }

        UserService.getUserSingleFamilyDetails(uuid, UserDetails.id).then(
          (response) => {
            let familyUserId = response.FamilyData.id;
            let familyId = response.FamilyData.Family.id;
            setfamilyUserId(familyUserId);
            setfamilyId(familyId);
            setfilterVal(
              userType === "AO" ||
                userType === "AO + SU" ||
                userType === "AO + AU" ||
                userType === "AO + AU + SU"
                ? filterVal
                : primaryArrVal[0]
                ? primaryArrVal[0].value
                : parseInt(PrimaryIdval)
            );
            const data = {
              fid: familyId,
              uid: familyUserId,
              filterValue:
                userType === "AO" ||
                userType === "AO + SU" ||
                userType === "AO + AU" ||
                userType === "AO + AU + SU"
                  ? filterVal
                  : primaryArrVal[0]
                  ? primaryArrVal[0].value
                  : parseInt(PrimaryIdval),
              limit: limit,
              offset: offset,
            };
            UserService.getRemData(tabVal, data).then(
              (resp) => {
                setAllData(resp.otherData);

                if (resp.otherData.length === 0) {
                  setIsEmpty(true);

                  sethasMore(false);
                } else {
                  setIsEmpty(false);
                  if (resp.otherData.length >= limit) {
                    setOffset(limit);
                    sethasMore(true);
                  } else {
                    sethasMore(false);
                  }
                }
                setTimeout(() => {
                  setloadingspinner(false);
                }, 500);
              },
              (error) => {}
            );
          }
        );
      },
      (error) => {}
    );
  }, []);

  const handleremindersett = () => {
    if (parentUserUUId === null) {
      history.push({
        pathname: `/group_settings/${uuidDetails}`,
      });
    } else {
      history.push({
        pathname: `/user_group_settings/${uuidDetails}/${userUuidDetails}`,
      });
    }
  };

  const closeDropdownSort = () => {
    setIsSortDropdown(false);
  };

  const toggleDropdownSort = () => {
    setIsSortDropdown((prev) => !prev); // Toggle the dropdown state
  };

  useEffect(() => {
    // Handler to detect clicks outside of the dropdown
    const handleClickOutside = (event) => {
      // handle filter dropdown

      // handle sort dropdown
      if (sortRef.current && !sortRef.current.contains(event.target)) {
        closeDropdownSort();
      }
    };

    // Bind the event listener for clicks outside
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Cleanup the event listener on component unmount
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Function to handle button click
  const handleButtonClick = (buttonType) => {
    setActiveButton(buttonType); // Set active button based on click
    settabVal(buttonType);
    setLimit(50);
    setOffset(0);
    const data = {
      fid: familyId,
      uid: familyUserId,
      filterValue: filterVal,
      limit: 50,
      offset: 0,
    };

    getReminder(buttonType, data);
  };

  // Function to handle button click
  const taskSort = (val) => {
    setfilterVal(val);
    setLimit(50);
    setOffset(0);
    const data = {
      fid: familyId,
      uid: familyUserId,
      filterValue: val,
      limit: 50,
      offset: 0,
    };

    getReminder(tabVal, data);
  };

  const getReminder = (val, data) => {
    setloading(true);
    UserService.getRemData(val, data).then(
      (resp) => {
        setAllData(resp.otherData);
        if (resp.otherData.length === 0) {
          setIsEmpty(true);

          sethasMore(false);
        } else {
          setIsEmpty(false);
          if (resp.otherData.length >= limit) {
            setOffset(limit);
            sethasMore(true);
          } else {
            sethasMore(false);
          }
        }
        setTimeout(() => {
          setloading(false);
        }, 500);
      },
      (error) => {}
    );
  };

  const fetchMoreData = () => {
    const data = {
      fid: familyId,
      uid: familyUserId,
      filterValue: filterVal,
      limit: limit,
      offset: offset,
    };
    setTimeout(() => {
      UserService.getRemData(tabVal, data).then(
        (response) => {
          setAllData([...allData, ...response.otherData]);
          let nextOffset = Number(offset) + Number(limit);

          if (response.otherData.length + allData.length >= nextOffset) {
            setOffset(nextOffset);
            sethasMore(true);
          } else {
            sethasMore(false);
          }
        },
        (error) => {}
      );
    }, 500);
  };
  return (
    <>
      {/* new code  */}
      <>
        <Container
          fluid
          style={{ minHeight: "calc(100vh - 17rem)", marginBottom: "6rem" }}
          className="d-flex flex-column"
        >
          <>
            <Row className="row align-items-center justify-content-md-end gy-xl-0 gx-2 gx-xl-3 mb-4">
              <Col>
                <h1 className="lh-base mb-0">Reminders</h1>
              </Col>

              {/* filter  */}
              <Col
                xs="auto"
                className="position-relative"
                ref={sortRef} // Ref to track button for outside clicks
              >
                <button
                  className={`border-white btn btn-white d-md-flex align-items-md-center shadow position-relative ${
                    isSortDropdown ? "dropdown-arrow" : ""
                  }`}
                  type="button"
                  id="dropdownMenuButton"
                  data-bs-toggle="dropdown"
                  onClick={toggleDropdownSort} // Toggle dropdown on click
                  aria-expanded={isSortDropdown}
                >
                  <i className="fa-solid fa-sm fa-filter lh-1 align-middle"></i>
                  <span className="text-dark ms-md-2 d-none d-md-block">
                    Filter by
                  </span>
                </button>
                {/* main dropdown  */}
                <ul
                  className={`dropdown-menu dropdown-parent mt-2 ${
                    isSortDropdown ? "show" : ""
                  }`}
                  ref={sortRef}
                  style={{
                    boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                  }}
                  aria-labelledby="dropdownMenuButton"
                >
                  <li>
                    {filtAll.map((option) => (
                      <div
                        key={option.value}
                        className="dropdown-item"
                        style={{
                          cursor: "pointer",
                          color:
                            selectedSort && selectedSort.value === option.value
                              ? "#020617"
                              : "",
                          backgroundColor:
                            selectedSort && selectedSort.value === option.value
                              ? "#36f1cc"
                              : "",
                        }}
                        onClick={() => {
                          setSelectedSort(option);
                          taskSort(option.value);
                          closeDropdownSort();
                        }}
                      >
                        {option.label}
                      </div>
                    ))}
                  </li>
                </ul>
              </Col>
            </Row>
            {loadingspinner ? (
              <>
                <Loading />
              </>
            ) : (
              <section className="bg-white p-4 p-md-5 p-lg-6 rounded-4 shadow h-100">
                <Row className="gx-3 gy-2 gx-md-5 gx-lg-7 mb-8">
                  <Col xs="12" md="auto">
                    <div className="h1 mb-0">
                      {tabVal === "other"
                        ? "Other reminders"
                        : "To-do reminders"}
                    </div>
                  </Col>
                  <Col className="d-flex justify-content-end align-items-end">
                    <div
                      className={`btn btn-sm ${
                        activeButton === "other" ? "bg-cayn" : "btn-white"
                      }`}
                      onClick={() => handleButtonClick("other")}
                      style={{
                        borderRadius: "8px 0 0 8px",
                      }}
                    >
                      Other
                    </div>
                    <div
                      className={`btn btn-sm ${
                        activeButton === "todo" ? "bg-cayn" : "btn-white"
                      }`}
                      onClick={() => handleButtonClick("todo")}
                      style={{
                        borderRadius: "0 8px 8px 0",
                      }}
                    >
                      To-do
                    </div>
                  </Col>
                </Row>
                {loading ? (
                  <Loading />
                ) : (
                  <>
                    {tabVal === "other" ? (
                      <Row className="gx-3 gy-0 gx-md-4 gx-lg-3 gx-xl-2 gx-xxl-3">
                        <Col xs="8" md="6" lg="5" xl="5">
                          <span className="small fw-semibold fs-17">
                            Module
                          </span>
                        </Col>
                        {/* <Col lg="6" xl="4" className="d-lg-block d-none">
                          <span className="small fw-semibold fs-17">Name</span>
                        </Col> */}
                        <Col xs="8" md="6" lg="5" xl="5">
                          <span className="small fw-semibold fs-17">
                            Category
                          </span>
                        </Col>

                        <Col xs="8" md="6" lg="5" xl="5">
                          <span className="small fw-semibold fs-17">
                            Supplier
                          </span>
                        </Col>

                        <Col xs="6" lg="5" xl="5" className="d-lg-block d-none">
                          <span className="small fw-semibold fs-17">
                            Amount
                          </span>
                        </Col>

                        <Col
                          xs="6"
                          md="6"
                          lg="4"
                          xl="4"
                          className="d-md-block d-none"
                        >
                          <span className="small fw-semibold fs-17">
                            Due date
                          </span>
                        </Col>
                      </Row>
                    ) : (
                      <Row className="gx-3 gy-0 gx-md-4 gx-lg-3 gx-xl-2 gx-xxl-3">
                        <Col xs="8" md="8" lg="6" xl="6">
                          <span className="small fw-semibold fs-17">Who</span>
                        </Col>
                        <Col
                          xs="8"
                          md="5"
                          lg="6"
                          xl="6"
                          className="d-lg-block d-none"
                        >
                          <span className="small fw-semibold fs-17">
                            Extra Info
                          </span>
                        </Col>
                        <Col xs="8" md="9" lg="6" xl="6">
                          <span className="small fw-semibold fs-17">What</span>
                        </Col>
                        <Col xs="8" md="6" lg="6" xl="6">
                          <span className="small fw-semibold fs-17">When</span>
                        </Col>
                      </Row>
                    )}
                    <hr className="mt-1 mb-3" />
                    {isEmpty ? (
                      <div className="text-center">
                        <p className="mt-4">
                          There is no reminders available on this query
                        </p>
                      </div>
                    ) : (
                      <>
                        <InfiniteScroll
                          dataLength={allData.length} // Set the length of the current data
                          next={fetchMoreData} // Trigger to load more data
                          hasMore={hasMore} // Check if more data is available
                          style={{
                            overflow: "visible",
                          }}
                          loader={
                            <div className="d-flex align-items-center gap-2 my-5 justify-content-center">
                              <span
                                className="spinner-border spinner-border-sm mr-2"
                                role="status"
                              ></span>
                              <span>Loading . . .</span>
                            </div>
                          }
                        >
                          {allData &&
                            allData.map((subData, index) => (
                              <React.Fragment key={subData.id}>
                                {tabVal === "other" ? (
                                  <Row className="align-items-center gx-3 gy-0 gx-md-4 gx-lg-3 gx-xl-2 gx-xxl-3">
                                    <Col xs="8" md="6" lg="5" xl="5">
                                      <div className="d-inline small  text-dark">
                                        {subData.type}
                                      </div>
                                    </Col>
                                    <Col xs="8" md="6" lg="5" xl="5">
                                      <div className="d-inline small  text-dark">
                                        {subData.category}
                                      </div>
                                    </Col>

                                    <Col xs="8" md="6" lg="5" xl="5">
                                      <div className="d-inline small  text-dark">
                                        {subData.supplier_name}
                                      </div>
                                    </Col>
                                    <Col
                                      lg="5"
                                      xl="5"
                                      className="d-lg-block d-none"
                                    >
                                      <div className="d-inline small  text-dark">
                                        £ {subData.amount}
                                      </div>
                                    </Col>

                                    <Col
                                      xs="6"
                                      md="6"
                                      lg="4"
                                      xl="4"
                                      className="d-md-block d-none"
                                    >
                                      <div className="d-inline small  text-dark">
                                        {subData.due_date
                                          ? moment(subData.due_date).format(
                                              "Do MMM, YYYY"
                                            )
                                          : "--"}
                                      </div>
                                    </Col>
                                  </Row>
                                ) : (
                                  <Row className="align-items-center gx-3 gy-0 gx-md-4 gx-lg-3 gx-xl-2 gx-xxl-3">
                                    <Col xs="8" md="8" lg="6" xl="6">
                                      <div className="small text-truncate text-dark">
                                        {subData.who}
                                      </div>
                                    </Col>
                                    <Col
                                      xs="8"
                                      md="5"
                                      lg="6"
                                      xl="6"
                                      className="d-lg-block d-none"
                                    >
                                      <div className=" small  text-dark text-truncate">
                                        {subData.extra_info}
                                      </div>
                                    </Col>
                                    <Col xs="8" md="9" lg="6" xl="6">
                                      <div className="text-truncate small  text-dark">
                                        {subData.what}
                                      </div>
                                    </Col>
                                    <Col xs="8" md="6" lg="6" xl="6">
                                      <div className="d-inline small  text-dark">
                                        {subData.when
                                          ? moment(subData.when).format(
                                              "Do MMM, YYYY"
                                            )
                                          : "--"}
                                      </div>
                                    </Col>
                                  </Row>
                                )}
                                {index !== allData.length - 1 && (
                                  <hr className="my-3" />
                                )}
                              </React.Fragment>
                            ))}
                        </InfiniteScroll>
                      </>
                    )}
                  </>
                )}
              </section>
            )}
          </>
        </Container>
      </>
    </>
  );
};
export default Reminders;
